import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'sa-bonus-event',
  templateUrl: './bonus-event.component.html',
  styleUrls: ['./bonus-event.component.scss'],
})
export class BonusEventComponent implements OnInit {
  selectedTabIndex = 0;

  constructor(private route: ActivatedRoute, public router: Router) {}

  ngOnInit(): void {
    const type = this.route.snapshot.params['type'];
    if (type === 'active') {
      this.selectedTabIndex = 0;
    } else if (type === 'completed') {
      this.selectedTabIndex = 1;
    }
  }

  public selectTab($event: any): void {
    this.selectedTabIndex = $event.index;
    if (this.selectedTabIndex === 0) {
      this.router.navigateByUrl('/bonus-event/active');
    } else if (this.selectedTabIndex === 1) {
      this.router.navigateByUrl('/bonus-event/completed');
    }
  }
}
